@reference "@glow/tailwind-config/reference.css";

.spinner {
  @apply flex;
  @apply flex-col;
  @apply items-center;
}
